import { useQuery } from '@tanstack/react-query';
import { calendarConnectionsService } from '../api/calendar-connections.service';
import { CALENDAR_CONNECTIONS_KEYS } from './queryKeys';
import type { CalendarConnection } from '../types';

/**
 * Lists the current user's external calendar connections (Google/Microsoft).
 * User-scoped query — no orgId in the key (connections skip X-Tenant-Id).
 */
export function useCalendarConnections(): {
  data: CalendarConnection[];
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useQuery({
    queryKey: CALENDAR_CONNECTIONS_KEYS.all,
    queryFn: ({ signal }) => calendarConnectionsService.getConnections(signal),
    staleTime: 60_000,
  });

  return {
    data: data ?? [],
    isLoading,
    isError,
  };
}
